/* eslint-disable @typescript-eslint/no-unused-vars */
import { iReviewFormValues } from '@services/ReviewService';
import { useFormikContext } from 'formik';
import { ReactElement, useEffect } from 'react';
import IndividualFormReview from '@components/Review/Individual/IndividualFormReview';
import CompanyFormReview from '@components/Review/Company/CompanyFormReview';
import ThirdPartyFormReview from '@components/Review/ThirdParty/ThirdPartyFormReview';

function ReviewStep10(): ReactElement {
    const { values }: { values: iReviewFormValues; } = useFormikContext<iReviewFormValues>();
    return (
      <>
        {values.isThirdPartyAuthorised && <ThirdPartyFormReview />}
        {(values.isDebtorTypeIndividual && !values.isThirdPartyAuthorised) && <IndividualFormReview />}
        {(values.isDebtorTypeCompany && !values.isThirdPartyAuthorised) && <CompanyFormReview />}
      </>
    );
}

export default ReviewStep10;
